export const tabsUserProspects = [
    {
        title: 'Registros Login',
        value: {
            type: 1,
            closed: 0,
        },
    },
    {
        title: 'Prospectos campañas',
        value: {
            type: 2,
            closed: 0,
        },
    },
    {
        title: 'Registros Login Cerrados',
        value: {
            type: 1,
            closed: 1,
        },
    },
    {
        title: 'Prospectos campañas cerrados',
        value: {
            type: 2,
            closed: 1,
        },
    },
];
